dmx.Component('google-places-search', {

    initialData:{
        results: [],
        hasMore: false,
        status: ''
    },

    attributes: {
        map: {
            type: String,
            default: null
        },

        latitude: {
            type: Number,
            default: null
        },

        longitude: {
            type: Number,
            default: null
        },

        radius: { // in meters
            type: Number,
            default: null
        },

        'bind-bounds': { // search inside map boundaries, ignores lat/lng/radius
            type: Boolean,
            default: false
        },

        keyword: { // A term to be matched against all available fields
            type: String,
            default: null
        },

        'open-now': { // Restricts results to only those places that are open right now.
            type: Boolean,
            default: false
        },

        type: { // supported types see: https://developers.google.com/places/supported_types?authuser=0
            type: String,
            default: null
        },

        'show-on-map': {
            type: Boolean,
            default: false
        }
    },

    methods: {
        nearby: function(name) { // name is optional
            var request = {};

            this.markers.forEach(function(marker) {
                // remove from map
                marker.setMap(null);
            });

            this.markers = [];

            if (this.props['bind-bounds']) {
                request.bounds = this.map.getBounds();
            } else if (this.props.latitude != null && this.props.longitude != null) {
                request.location = { lat: this.props.latitude, lng: this.props.longitude };

                if (this.props.radius) {
                    request.radius = this.props.radius;
                }
            } else if (this.props.radius) {
                request.location = this.map.getCenter();
                request.radius = this.props.radius;
            }

            request.openNow = this.props['open-now'];

            if (this.props.type) {
                request.type = this.props.type;
            }

            if (name) {
                request.name = name;
            }

            var service = new google.maps.places.PlacesService(this.map);
            service.nearbySearch(request, this.onresults.bind(this));
        },

        search: function(query) {
            var request = { query: query };

            this.markers.forEach(function(marker) {
                // remove from map
                marker.setMap(null);
            });

            this.markers = [];

            if (this.props['bind-bounds']) {
                request.bounds = this.map.getBounds();
            } else if (this.props.latitude != null && this.props.longitude != null) {
                request.location = { lat: this.props.latitude, lng: this.props.longitude };

                if (this.props.radius) {
                    request.radius = this.props.radius;
                }
            } else if (this.props.radius) {
                request.location = this.map.getCenter();
                request.radius = this.props.radius;
            }

            request.openNow = this.props['open-now'];

            if (this.props.type) {
                request.type = this.props.type;
            }

            var service = new google.maps.places.PlacesService(this.map);
            service.textSearch(request, this.onresults.bind(this));
        },

        getMore: function() {
            if (this.pagination && this.pagination.hasNextPage) {
                this.pagination.nextPage();
            }
        }
    },

    render: function(node) {
        this.markers = [];
        this.target = document.getElementById(this.props.map);
        this.map = this.target && this.target.dmxComponent && this.target.dmxComponent.map;
    },

    update: function(props) {
        if (this.props.map && !this.map) {
            this.map = this.target && this.target.dmxComponent && this.target.dmxComponent.map;
        }
    },

    onresults: function(results, status, pagination) {
        this.set('status', status);
        this.set('hasMore', !!(pagination && pagination.hasNextPage));

        this.pagination = pagination;

        if (status == 'OK') {
            this.set('results', results.map(function(place) {
                return {
                    placeId: place.place_id,
                    address: place.formatted_address,
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng(),
                    icon: place.icon,
                    name: place.name,
                    priceLevel: place.price_level,
                    rating: place.rating,
                    types: place.types,
                    vicinity: place.vicinity,
                    openNow: place.opening_hours && place.opening_hours.open_now
                }
            }));

            if (this.props['show-on-map']) {
                // create markers on map
                results.forEach(function(place) {
                    var image = {
                        url: place.icon,
                        size: new google.maps.Size(71, 71),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(17, 34),
                        scaledSize: new google.maps.Size(25, 25)
                    };

                    var marker = new google.maps.Marker({
                        map: this.map,
                        icon: image,
                        title: place.name,
                        position: place.geometry.location
                    });

                    this.markers.push(marker);
                }, this);
            }
        } else {
            console.warn('nearbySearch failed.', status);
        }
    }

});
